import { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [adminUser, setAdminUser] = useState(null);
  const [adminToken, setAdminToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const savedAdminToken = localStorage.getItem('adminToken');
    const savedAdminUser = localStorage.getItem('adminUser');

    if (savedAdminToken && savedAdminUser) {
      try {
        setAdminToken(savedAdminToken);
        setAdminUser(JSON.parse(savedAdminUser));
      } catch (err) {
        console.error('Failed to parse saved admin JSON:', err);
        localStorage.removeItem('adminUser');
        localStorage.removeItem('adminToken');
      }
    }

    setIsLoading(false);

    const handleStorageChange = (e) => {
      if (e.key === 'adminToken' || e.key === 'adminUser') {
        if (!e.newValue) {
          setAdminToken(null);
          setAdminUser(null);
        } else if (e.key === 'adminToken') {
          setAdminToken(e.newValue);
        } else if (e.key === 'adminUser') {
          try {
            setAdminUser(JSON.parse(e.newValue));
          } catch (err) {
            console.error('Failed to parse admin from storage event:', err);
          }
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const adminLogin = (adminData, authToken) => {
    if (!adminData?.isAdmin || adminData.username !== 'admin') return;

    setAdminUser(adminData);
    setAdminToken(authToken);
    localStorage.setItem('adminToken', authToken);
    localStorage.setItem('adminUser', JSON.stringify(adminData));
  };

  const logoutAdmin = () => {
    setAdminUser(null);
    setAdminToken(null);
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
  };

  return (
    <AuthContext.Provider value={{
      adminUser,
      adminToken,
      adminLogin,
      logoutAdmin,
      isLoading,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
